import React from "react";
import { CustomIcon } from "../shared/CustomIcon";

// DepartmentWidget — compact home-dashboard card for a single department.
// Shows logo, name, effective priority, member count, leader, and an
// "Override Active" pill when applicable. Tapping navigates to detail.
export default function DepartmentWidget({ dept, memberCount, leader, navigate }) {
  if (!dept) {
    return (
      <div className="widget-empty" data-testid="dept-widget-missing">
        This department is no longer available.
      </div>
    );
  }
  const effectivePriority = dept.effectivePriority || dept.priority || "medium";
  const overrideActive = !!dept.overrideActive;
  return (
    <button
      type="button"
      data-testid={`dept-widget-${dept.id}`}
      onClick={() => navigate(`/departments/${dept.id}`)}
      style={{
        display: "flex", alignItems: "center", gap: 12, width: "100%",
        textAlign: "left", padding: "10px 14px",
        background: "transparent", border: "none", cursor: "pointer",
        color: "inherit", fontFamily: "inherit",
      }}
    >
      <span
        className="dept-logo"
        style={{ width: 44, height: 44, fontSize: 22, flexShrink: 0 }}
        aria-hidden="true"
      >
        {dept.logoUrl ? <img src={dept.logoUrl} alt="" /> : <CustomIcon name="tools" size={24} />}
      </span>
      <span style={{ display: "block", flex: 1, minWidth: 0 }}>
        <span style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          <span style={{ fontFamily: "'Cinzel',serif", fontSize: 14, fontWeight: 700, color: "var(--kc-text)", textTransform: "uppercase", letterSpacing: "0.05em", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 200 }}>
            {dept.name}
          </span>
          <span className={`priority-badge ${effectivePriority}`}>{effectivePriority}</span>
          {overrideActive && (
            <span
              data-testid={`dept-widget-override-${dept.id}`}
              style={{
                fontSize: 9, letterSpacing: "0.06em",
                background: "color-mix(in srgb, var(--kc-accent) 16%, transparent)", border: "1px solid color-mix(in srgb, var(--kc-accent) 55%, transparent)",
                color: "var(--kc-accent)", borderRadius: 999, padding: "2px 7px",
                fontFamily: "'Montserrat',sans-serif", fontWeight: 700, textTransform: "uppercase",
                display: "inline-flex", alignItems: "center", gap: 3,
              }}
            ><CustomIcon name="bolt" size={9} /> Override</span>
          )}
        </span>
        <span style={{ display: "block", fontFamily: "'Montserrat',sans-serif", fontSize: 11, color: "var(--kc-sub)", marginTop: 3 }}>
          {memberCount} member{memberCount === 1 ? "" : "s"}
          {leader ? <> · Leader: <span style={{ color: "var(--kc-text)" }}>{leader}</span></> : null}
        </span>
      </span>
      <span
        aria-hidden="true"
        style={{ color: "var(--kc-meta)", fontSize: 14, flexShrink: 0 }}
      >→</span>
    </button>
  );
}
